import React from 'react';
import { Link } from 'react-router-dom';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
const Service = ({ service }) => {
    const { _id, price, rating, title, image_url, details } = service
    return (
        <div className="card card-compact bg-base-100 shadow-xl">
            <figure>
                {
                    <PhotoProvider>
                        <PhotoView src={image_url}>
                            <img src={image_url} alt="Shoes" className='w-80 h-60' />
                        </PhotoView>
                    </PhotoProvider>
                }
            </figure>
            <div className="card-body">
                <h2 className="card-title">{title}</h2>
                <p>{details.length >= 100 ? details.slice(0, 100) + '...' : details}</p>
                <p>Ratings : {rating}</p>
                <div className="card-actions justify-end items-center">
                    <p>Price: {price}tk</p>
                    <Link to={`/service/${_id}`}><button className="btn min-h-8 h-8 btn-primary">View Details</button></Link>
                </div>
            </div>
        </div>
    );
};

export default Service;